import { HTMLExtUtils } from '@ssml-editor/core';
import { SPEAK_TYPE } from './constant.js';
import { Effect } from './effect.enum.js';

const speakHtmlToElement = ({
  element,
  children
}) => {
  const mark = HTMLExtUtils.getDataAttribute(element, "mark", "");
  const rate = HTMLExtUtils.getDataAttribute(element, "rate", 1);
  const pitch = HTMLExtUtils.getDataAttribute(element, "pitch", 1);
  const volume = HTMLExtUtils.getDataAttribute(element, "volume", 100);
  const effect = HTMLExtUtils.getDataAttribute(element, "effect") ? Effect.fromString(HTMLExtUtils.getDataAttribute(element, "effect")) : void 0;
  const effectValue = HTMLExtUtils.getDataAttribute(element, "effect-value");
  const bgm = HTMLExtUtils.getDataAttribute(element, "bgm");
  const bgmName = HTMLExtUtils.getDataAttribute(element, "bgmName");
  const bgmVolume = HTMLExtUtils.getDataAttribute(element, "bgm-volume") ? +HTMLExtUtils.getDataAttribute(element, "bgm-volume") : void 0;
  return {
    type: SPEAK_TYPE,
    mark,
    rate,
    pitch,
    volume,
    effect,
    effectValue,
    bgm,
    bgmName,
    bgmVolume,
    children
  };
};

export { speakHtmlToElement };
//# sourceMappingURL=html-to-element.js.map
